export default __webpack_public_path__ + "static/media/login_logo_red@2x.3bc23306.png";